import { BulkHpiIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_BULK_HPI: AppConfig = {
  name: 'Bulk HPI Data',
  applicationKey: 'bulk-hpi',
  type: 'product',
  appSlugForEngagement: AppSlugs.BulkHpi,
  rootPath: `/bulk-hpi`,
  Icon: BulkHpiIcon,
  descriptionLong:
    'Bulk HPI Data at the Zip/MSA/State levels, delivered monthly.',
  descriptionShort: 'Bulk HPI Data at the Zip/MSA/State levels',
};
